// 帖子相关的 Action 层，负责业务逻辑和异步操作
import { action, makeObservable } from 'mobx';
import { CommonStore } from './store';
import { readBannerList, readSettings, readInviteLinkCreate, readCarnivalActivities } from '@server/api';


export class CommonAction extends CommonStore {

    constructor(props) {
        super(props);
        makeObservable(this);
    }

    /**
     * 获取关注的话题列表
     */
    async getBannerList(params) {
        const res = await readBannerList(params);
        return res
    }

    /**
     * 获取我的试用码
     * @returns 试用码信息
     */
    @action
    async getInviteLinkCreate(params) {
        const ret = await readInviteLinkCreate(params);
        return ret;
    }

    /**
     * 获取设置
     */
    async getSettings(params) {
        const res = await readSettings(params);
        return res
    }

    /**
     * 获取嘉年华活动详情
     * @param {object} params 查询参数
     *   - params.code: 活动 code
     * @returns 活动详情数据
     */
    async getCarnivalActivities(params) {
        const res = await readCarnivalActivities(params);
        return res;
    }

}

// 单例导出，方便全局调用
const commonAction = new CommonAction();
export default commonAction;